import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class stepService extends ApiBaseService {
  constructor(public http: HttpClient) {
    super(http, '/steps');
  }

  checkNameExist(name: string, userId?: string): Observable<any> {
    const params = { name };
    const id = userId ? userId : null;
    return this.http.get(`${environment.apiUrl}/steps/name/${id}`, {
      params,
    });
  }
}
